import { render, staticRenderFns } from "./PreLoader.vue?vue&type=template&id=1722de62&scoped=true&"
import script from "./PreLoader.vue?vue&type=script&lang=js&"
export * from "./PreLoader.vue?vue&type=script&lang=js&"
import style0 from "./PreLoader.vue?vue&type=style&index=0&id=1722de62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1722de62",
  null
  
)

export default component.exports